import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAppStore } from './stores/app';
import { useGameEvents } from './hooks/useGameEvents';
import { PlatformProvider } from './platform';
import { HomePage } from './pages/Home';
import { LobbyPage } from './pages/Lobby';
import { GamePage } from './pages/Game';
import { FinishedPage } from './pages/Finished';
import { TVModePage } from './pages/TVMode';
import { BrainSwipePage } from './pages/BrainSwipePage';
import { DailyChallengePage } from './pages/DailyChallengePage';
import CollectionsPage from './pages/CollectionsPage';
import CollectionDetailPage from './pages/CollectionDetailPage';
import CollectionPlayPage from './pages/CollectionPlayPage';
import LessonPage from './pages/LessonPage';
import ModulePage from './pages/ModulePage';
import ProfilePage from './pages/ProfilePage';
import { SupportPage } from './pages/SupportPage';
import { PricingPage } from './pages/PricingPage';
import { TermsPage } from './pages/TermsPage';
import { RefundPage } from './pages/RefundPage';
import { PayReturnPage } from './pages/PayReturnPage';
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminCourses from "./pages/admin/AdminCourses";
import AdminCourseEditor from "./pages/admin/AdminCourseEditor";
import EmbedLayout from './components/EmbedLayout';
import EmbedCollectionPage from './pages/embed/EmbedCollectionPage';
import EmbedModulePage from './pages/embed/EmbedModulePage';
import EmbedLessonPage from './pages/embed/EmbedLessonPage';
import EmbedPlayPage from './pages/embed/EmbedPlayPage';
import { BuyGamesModal } from './components/BuyGamesModal';
import { isCoursesSite } from './platform/detect';

function PlayerRouter() {
  const screen = useAppStore((s) => s.screen);
  // Подключаем обработчики событий
  useGameEvents();
  // Роутинг по состоянию
  switch (screen) {
    case 'home':
      return <HomePage />;
    case 'lobby':
      return <LobbyPage />;
    case 'game':
      return <GamePage />;
    case 'finished':
      return <FinishedPage />;
    default:
      return <HomePage />;
  }
}

function JoinRedirect() {
  // Страница /join?code=XXXX просто редиректит на главную с кодом
  return <Navigate to="/" replace />;
}

export default function App() {
  // Оболочка одна на две витрины, а <title> в index.html — «Beshek — Party Games».
  // На сайте курсов вкладка и поисковая выдача должны звать его курсами (владелец, 04.09.2026).
  useEffect(() => {
    if (isCoursesSite()) document.title = 'Курсы BESHEK — обучение с проверкой и сертификатом';
  }, []);
  return (
    <PlatformProvider>
      <BuyGamesModal />
      <Routes>
        {/* Daily Challenge */}
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/refund" element={<RefundPage />} />
        <Route path="/pay/return" element={<PayReturnPage />} />
        <Route path="/daily" element={<DailyChallengePage />} />
        {/* Collections */}
        <Route path="/collections" element={<CollectionsPage />} />
        <Route path="/collections/:id" element={<CollectionDetailPage />} />
        <Route path="/collections/:id/lesson/:moduleId" element={<LessonPage />} />
        <Route path="/collections/:id/module/:moduleId" element={<ModulePage />} />
        <Route path="/collections/:id/play/:moduleId" element={<CollectionPlayPage />} />
        {/* Admin */}
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/courses" element={<AdminCourses />} />
        <Route path="/admin/courses/:id" element={<AdminCourseEditor />} />
        <Route path="/embed/collection/:id" element={<EmbedLayout><EmbedCollectionPage /></EmbedLayout>} />
        <Route path="/embed/collection/:id/module/:moduleId" element={<EmbedLayout><EmbedModulePage /></EmbedLayout>} />
        <Route path="/embed/collection/:id/lesson/:moduleId" element={<EmbedLayout><EmbedLessonPage /></EmbedLayout>} />
        <Route path="/embed/collection/:id/play/:moduleId" element={<EmbedLayout><EmbedPlayPage /></EmbedLayout>} />
        {/* BrainSwipe */}
        <Route path="/swipe/*" element={<BrainSwipePage />} />
        {/* TV Mode */}
        <Route path="/tv" element={<TVModePage />} />
        {/* Join redirect */}
        <Route path="/join" element={<JoinRedirect />} />
        {/* Main player flow */}
        <Route path="/*" element={isCoursesSite() ? <CollectionsPage /> : <PlayerRouter />} />
        {/* Embed — встраиваемые курсы */}
       
      </Routes>
    </PlatformProvider>
  );
}
